export default __webpack_public_path__ + "static/media/Foot_right.289a2ac5.svg";